import { combineReducers } from 'redux'
import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path: 'off-package-loader',

  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const OffPackageLoader = require('./components/OffPackageLoader').default
      const fileUploadReducer = require('./modules/fileUpload').default

      injectReducer(store, {
        key: 'offPackageLoader',
        reducer: combineReducers({
          upc: combineReducers({
            upload: fileUploadReducer.bind(null, 'upc')
          }),
          dictionary: combineReducers({
            upload: fileUploadReducer.bind(null, 'dictionary')
          })
        })
      })

      cb(null, OffPackageLoader)
    }, 'offPackageLoader')
  }
})



// WEBPACK FOOTER //
// ./src/routes/OffPackageLoader/index.js